<template>
  <div>
    Loading...
  </div>
</template>

<script>
export default {
  name: 'Loader'
}
</script>



// WEBPACK FOOTER //
// src/components/elements/Loader.vue